export const PageUrlYdMp = {
    refund: {
        url: "/ydmprefund",
    },
    labelPrint: {
        url: "/ydmplabelprint",
    },
};
  